import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Dropdown } from 'shared/ui'
import { type SmartView } from 'entities/SmartViews/model/SmartView'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import {
  actionTeamsFavorite,
  menuTeamsFavorite,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/TeamsFavorite'
import {
  actionEditSmartView,
  menuEditSmartView,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/EditSmartView'
import {
  actionDeleteSmartView,
  menuDeleteSmartView,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/DeleteSmartView'

type IDropdownSimpleInboxProps = {
  inbox: SmartView
}

export const DropdownSmartViewInbox: FC<IDropdownSimpleInboxProps> = observer(({ inbox }) => {
  const store = useConversationMenuContext()
  const items = [menuTeamsFavorite(inbox), menuEditSmartView(), menuDeleteSmartView()]

  return (
    <Dropdown
      ariaLabel={'DropdownSimpleInbox'}
      icon={'moreHorizontal'}
      placement={'bottom-end'}
      tooltipProps={{
        disableInteractive: true,
        label: 'Show actions',
        placement: 'top-end',
      }}
      items={items}
      onChange={(item, parent) => {
        actionTeamsFavorite({ inbox, item }, store)
        actionEditSmartView({ inbox, item }, store)
        actionDeleteSmartView({ inbox, item }, store)
      }}
      width={118}
    />
  )
})
